import { theme } from '@provi/provi-components'
import styled from 'styled-components'

export const ContainerInvoices = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
`

export const ItemInvoice = styled.div`
  position: relative;
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.1);
  display: flex;
  margin-top: 8px;
  flex-direction: column;
  background-color: ${theme.colors.white100};
  justify-content: space-between;
  border-radius: 10px;
  padding: 16px;
  min-height: ${({ minHeight }) => (minHeight ? minHeight : 200)}px;
  width: 600px;
  box-sizing: border-box;
  ${({ active }) => active && 'border: 1px solid #DE0C4B;'};
  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.grey600};
  font-family: 'CenturyGothicBold', sans-serif;

  ${theme.breakpoints.down('md')} {
    font-size: 12px;
    line-height: 18px;
    margin-right: 8px;
    text-align: right;
  }
`

export const TextModal = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.blue900};
  font-family: 'CenturyGothic', sans-serif;

  ${theme.breakpoints.down('md')} {
    font-size: 12px;
    line-height: 18px;
    margin-right: 8px;
    text-align: left;
  }
`

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`

export const Month = styled.p`
  display: flex;
  flex-direction: column;
  margin: 0;
  font-size: 12px;
  ${theme.breakpoints.down('md')} {
    margin-top: 16px;
  }
`

export const Price = styled.p`
  display: flex;
  flex-direction: column;
  margin: 0;
  font-family: 'CenturyGothicBold', sans-serif;
  color: ${theme.colors.blue900};
  font-size: 20px;
  line-height: 30px;
`

export const Right = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.grey500};
  font-family: 'CenturyGothicBold', sans-serif;
  justify-content: flex-end;
  width: 50%;

  ${theme.breakpoints.down('md')} {
    font-size: 12px;
    line-height: 18px;
  }
`

export const Status = styled.div`
  margin-left: 8px;
  width: 18px;
  height: 18px;
  background-color: ${props => props.color};
  border-radius: 50%;
`

export const Header = styled.div`
  display: flex;
`

export const WrapperQuestion = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 50px;
  height: 50px;
  display: flex;
  cursor: pointer;
  justify-content: flex-end;
`

export const ButtonGroup = styled.div`
  width: 350px;
  border-radius: 50px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  border: 1px solid ${theme.colors.blue900};
  margin-bottom: 20px;
  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`

export const ButtonItemLeft = styled.div`
  cursor: pointer;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  line-height: 18px;
  background-color: ${({ active }) => (active ? theme.colors.blue900 : 'transparent')};
  color: ${({ active }) => (active ? theme.colors.white100 : theme.colors.blue900)};
  font-family: ${({ active }) => (active ? 'CenturyGothicBold, sans-serif' : 'CenturyGothic, sans-serif')};
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  &:hover {
    opacity: 0.7;
  }
  ${theme.breakpoints.down('md')} {
    font-size: 12px;
    line-height: 18px;
  }
`

export const ButtonItemRight = styled.div`
  cursor: pointer;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  line-height: 18px;
  background-color: ${({ active }) => (active ? theme.colors.blue900 : 'transparent')};
  font-family: ${({ active }) => (active ? 'CenturyGothicBold, sans-serif' : 'CenturyGothic, sans-serif')};
  color: ${({ active }) => (active ? theme.colors.white100 : theme.colors.blue900)};
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  &:hover {
    opacity: 0.7;
  }
  ${theme.breakpoints.down('md')} {
    font-size: 12px;
    line-height: 18px;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ButtonPayment = styled.div`
  font-family: 'CenturyGothicBold', sans-serif;
  height: 25px;
  border: 1px solid ${theme.colors.pink900};
  color: ${theme.colors.pink900};
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  box-sizing: border-box;
  border-radius: 20px;
  position: absolute;
  right: 15px;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
`

export const TextTitle = styled.p`
  font-family: 'CenturyGothicBold', sans-serif;
  color: ${theme.colors.blue900};
  font-size: 24px;
  line-height: 30px;
  margin: 0;
`

export const TextSimple = styled.p`
  font-family: 'CenturyGothic', sans-serif;
  color: ${theme.colors.blue900};
  font-size: 12px;
  line-height: 24px;
  margin: 0;
`

export const ContainerText = styled.div`
  margin-top: 50px;
  text-align: center;
`

export const TextMsg = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.blue900};
  font-family: 'CenturyGothicBold', sans-serif;

  ${theme.breakpoints.down('md')} {
    font-size: 12px;
    line-height: 18px;
  }
`

export const SubTitle = styled.p`
  font-family: 'CenturyGothicBold', sans-serif;
  color: ${theme.colors.blue900};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
`

export const AlertUpAllowance = styled.div`
  max-width: 600px;
  width: 100%;
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;
`

export const WrapperButton = styled.div`
  ${theme.breakpoints.down('sm')} {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    & > div {
      width: 256px;
    }
  }
`

export const ContainerNewPortal = styled.div`
  margin-top: 84px;
  padding-top: 40px;
  padding-right: 32px;
  padding-bottom: 20px;
  padding-left: 360px;
  filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.14));
  background-color: white;
  border-radius: 16px;

  display: flex;
  position: relative;

  ${theme.breakpoints.down('md')} {
    padding: 16px;
  }
`

export const ContainerImage = styled.img`
  height: 350px;

  margin-top: -84px;
  left: 52px;
  bottom: 0;
  position: absolute;

  ${theme.breakpoints.down('md')} {
    display: none;
  }
`

export const ContainerNewPortalContainer = styled.div``

export const ContainerNewPortalTitle = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 30px;
  font-weight: 700;
  line-height: 36px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin-right: 50px;
`

export const ContainerNewPortalText = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;

  strong {
    font-weight: 700;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`
export const WarningText = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0;
  font-size: ${({ size = 'small' }) => (size === 'large' ? '20px' : '12px')};
  line-height: 16px;
  color: ${theme.colors.red100};
  font-family: 'CenturyGothicBold', sans-serif;

  ${theme.breakpoints.down('md')} {
    font-size: 12px;
    line-height: 18px;
    text-align: center;
  }
`

export const ContainerWarning = styled.div`
  margin: 20px;
`

export const OverdueBanner = styled.div`
  width: 560px;
  background: #fdebdc;
  border-radius: 12px;
  padding: 20px;
  margin: 16px 0 24px 0;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`

export const OverdueHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`

export const OverdueIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${theme.colors.orange100 || '#F2994A'};
  color: ${theme.colors.white100};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-family: 'CenturyGothicBold', sans-serif;
`

export const OverdueTitle = styled.div`
  font-family: 'CenturyGothicBold', sans-serif;
  color: ${theme.colors.blue900};
  font-size: 18px;
  line-height: 24px;
`

export const OverdueText = styled.p`
  margin: 0 0 16px 0;
  font-family: 'CenturyGothic', sans-serif;
  color: ${theme.colors.blue900};
  font-size: 14px;
  line-height: 20px;
`

export const OverdueCTAWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 4px;
`

// Estilos para banner de assinatura pendente
export const SignatureBanner = styled.div`
  width: 560px;
  background: #f5f5f5;
  border-radius: 12px;
  padding: 20px;
  margin: 16px 0 24px 0;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`

export const SignatureBannerHeader = styled.div`
  display: flex;
  align-items: center;
  background: #999999;
  border-radius: 8px;
  padding: 12px 16px;
  color: #fff;
  margin-bottom: 16px;
`

export const SignatureBannerHeaderIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`

export const SignatureBannerHeaderText = styled.span`
  font-family: 'CenturyGothicBold', sans-serif;
  font-size: 14px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`

export const SignatureBannerDescription = styled.p`
  font-family: 'CenturyGothic', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
  margin: 0 0 16px 0;
`

export const SignaturesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
`

export const SignatureCard = styled.div`
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 12px 16px;
`

export const SignatureCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const SignatureCardTitle = styled.span`
  font-family: 'CenturyGothicBold', sans-serif;
  font-size: 14px;
  color: #1f2937;
`

export const SignatureStatusBadge = styled.span`
  font-family: 'CenturyGothicBold', sans-serif;
  font-size: 12px;
  color: ${props => (props.variant === 'success' ? '#065F46' : '#92400E')};
  background: ${props => (props.variant === 'success' ? '#D1FAE5' : '#FDE68A')};
  padding: 4px 12px;
  border-radius: 999px;
`

export const SignatureCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const SignatureCardName = styled.span`
  font-family: 'CenturyGothicBold', sans-serif;
  font-size: 14px;
  color: #262626;
`

export const SignatureCardDetail = styled.span`
  font-family: 'CenturyGothic', sans-serif;
  font-size: 12px;
  color: #666666;
`

export const SignatureNote = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #ebf8ff;
  border-radius: 8px;
  padding: 12px;
`

export const SignatureNoteIcon = styled.div`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SignatureNoteText = styled.span`
  font-family: 'CenturyGothic', sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: #0088cc;
`
